import { Table, Project, TableColumn } from '../../../types/domain';
import {
  Fingerprint,
  User,
  Brackets,
  Type,
  Hash,
  DollarSign,
  Mail,
  Calendar,
  Paperclip,
  ToggleLeft,
  CreditCard,
  FileCode,
} from 'lucide-react';

export interface SchemaTabProps {
  table: Table;
  project: Project;
  canEdit: boolean;
  columns?: TableColumn[];
  onColumnsUpdated?: (columns: TableColumn[]) => void;
  onTableUpdated: (table: Table) => void;
}

export const DATA_TYPES = [
  { value: 'text', label: 'Text (String)' },
  { value: 'number', label: 'Number (Float / Decimal)' },
  { value: 'boolean', label: 'Boolean (true / false)' },
  { value: 'email', label: 'Email' },
  { value: 'date', label: 'Date & Time' },
  { value: 'uuid', label: 'UUID (Primary / Identifier)' },
  { value: 'object', label: '{ } Single Item (Object)' },
  { value: 'array', label: '[ { } ] List of Items (Array)' },
  { value: 'file', label: 'File / Attachment' },
];

export const SUBFIELD_DATA_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'email', label: 'Email' },
  { value: 'date', label: 'Date' },
  { value: 'uuid', label: 'UUID' },
  { value: 'file', label: 'File' },
];

export const getFieldIcon = (dataType: string, key: string, name: string) => {
  const k = (key + ' ' + name).toLowerCase();
  const dt = dataType?.toLowerCase() || 'text';

  if (dt === 'uuid' || k === 'id' || k.endsWith('_id') || k.startsWith('id_') || k.includes('uuid')) {
    return Fingerprint;
  }
  if (dt === 'object' || dt === 'json') {
    if (k.includes('user') || k.includes('customer') || k.includes('author') || k.includes('contact') || k.includes('client')) {
      return User;
    }
    return FileCode;
  }
  if (dt === 'array' || dt === 'list') {
    return Brackets;
  }
  if (dt === 'email' || k.includes('email')) {
    return Mail;
  }
  if (dt === 'date' || k.includes('date') || k.includes('time') || k.includes('at')) {
    return Calendar;
  }
  if (dt === 'file' || dt === 'attachment') {
    return Paperclip;
  }
  if (dt === 'boolean' || k.startsWith('is_') || k.startsWith('has_') || k.includes('opt_')) {
    return ToggleLeft;
  }
  if (dt === 'number') {
    if (k.includes('price') || k.includes('cost') || k.includes('usd') || k.includes('amount') || k.includes('total') || k.includes('fee')) {
      return DollarSign;
    }
    return Hash;
  }
  if (k.includes('status') || k.includes('payment')) {
    return CreditCard;
  }
  return Type;
};
